<template>
  <div>
    <div>
    </div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold noprint">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/orders">Orders</Link>
      <span class="text-indigo-400 font-medium"> /</span>
      #{{ pad(order.id) }}
      <span v-if="purchaseorder.data[0].ordertype == 'TRUSS'">/ Building {{ purchaseorder.data[0].building }} / Level {{ purchaseorder.data[0].floor }} &nbsp; &nbsp; </span>
       <button @click="makePDF"><icon name="printer" class="mr-2 w-4 h-4" :class="'fill-indigo-400 group-hover:fill-white'" /></button>
    </h1>
    <h1 class="onlyprint">Order #{{ pad(order.id) }} <span v-if="purchaseorder.data[0].ordertype == 'TRUSS'">/ Building {{ purchaseorder.data[0].building }} / Level {{ purchaseorder.data[0].level }}</span></h1>
    <trashed-message v-if="order.deleted_at" class="mb-6" @restore="restore"> This PO has been deleted. </trashed-message>
    <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden" id="ordercontainer">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 sm:p-1 md:p-8">

          
          <div class="pb-4 pr-6 w-1/2"> Sold To:<br/><br/>
          <textarea :error="form.errors.soldto" rows="5" class="mb-4 ml-0 p-2 w-full bg-gray-300 hide" label="Sold To" v-model="form.soldto" placeholder=""></textarea>
          </div>
          <div class="pb-4 pr-6 w-1/2"> Ship To: <SelectInput class="p-2 w-full" disabled="disabled" id="orderjobsite" v-model="form.jobsite_id">
            <option>--Select a Jobsite--</option>
            <option v-for="jobsite in jobsitedata()" :value="jobsite.id" :selected="(order.jobsite_id == jobsite.id) ? 'selected' : ''">{{jobsite.sitename}}</option>
            </SelectInput>
            <br/>
            <br/>
          <!--<textarea :error="form.errors.shipto" rows="5" disabled="disabled" class="mb-4 ml-0 p-2 w-full bg-gray-300" label="S\hip To" v-model="form.shipto" ></textarea>-->
          </div>

          <!--<div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Projected Delivery: </div>
            <datepicker v-model="form.projected_delivery" :enableTimePicker="false" autoApply :error="form.errors.projected_delivery" class="pb-4 pr-2" label="Projected Delivery"/>
          </div>-->

          <!--<div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Actual Delivery: </div>
            <datepicker v-model="form.actual_delivery" :enableTimePicker="false" autoApply :error="form.errors.actual_delivery" class="pb-4 pr-2" label="Actual Delivery"/>
          </div>-->


          <div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Order Date: </div>
            <datepicker v-model="form.order_date" :enableTimePicker="false" autoApply :error="form.errors.order_date" class="pb-4 pr-2 " label="Order Date" />
          </div>


          <div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Cutoff Date: </div>
            <datepicker v-model="form.cutoff_date" :enableTimePicker="false" autoApply :error="form.errors.cutoff_date" class="pb-4 pr-2" label="Cutoff Date" />
          </div>
         
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-4 pr-6 w-1/4" label="Phone" placeholder="(254) 111-1111" />
          <text-input v-model="form.fob" :error="form.errors.fob" class="pb-4 pr-6 w-1/4" label="F.O.B." placeholder="Jobsite" />
          <text-input v-model="form.trader" :error="form.errors.trader" class="pb-4 pr-6 w-1/4" label="Trader" placeholder="" />
          <text-input v-model="form.payment_terms" :error="form.errors.payment_terms" class="pb-4 pr-6 w-1/4" label="Payment Terms" placeholder="NET30" />
          <text-input v-model="form.routing" :error="form.errors.routing" class="pb-4 pr-6 w-1/4" label="Routing" placeholder="Truck" />
          <text-input v-model="form.bid_id" :error="form.errors.bid_id" class="pb-4 pr-6 w-1/4" label="Bid ID" placeholder="" />
          
          <div class="w-full mb-4 md:pr-6">
            <h2 class="mb-4 text-2xl font-bold">Items</h2> 
              <div v-if="purchaseorder.data[0].ordertype =='TRUSS' || purchaseorder.data[0].ordertype =='HARDWARE'" id="autodate" v-show="(auth.user.role !== 'VENDOR' && auth.user.role !== 'CLIENT')">
                <br/>
                <span style="cursor:pointer; float:right;" class="signature-button button btn" @click="autoQtyUpdate()">Auto QTY</span>
                <span style="cursor:pointer;" class="signature-button button btn" @click="dateOrderItems(form.autodate)">Update</span>
                <label>Autofill all dates:
                    <datepicker :enableTimePicker="false" autoApply v-model="form.autodate" class="pb-4 pr-2 w-1/4 " label="Date All" />
                </label>
                <br/>
              </div>
            <div id="orderstable" class="loading"></div>
            <text-input v-show="true" v-model="form.products" id="productsdata" :error="form.errors.products" />
          </div>
          <div class="w-full nobreak">
            <h2 class="mb-4 text-2xl font-bold">Signature</h2>
            <Vue3Signature ref="signature1" :sigOption="state.option" :w="'auto'" :h="'200px'" 
                :disabled="state.disabled" :defaultUrl="(form.signature ? form.signature : '')" class="pr-6 nobreak"></Vue3Signature>
            <button v-show="(form.status < 5 && (auth.user.role == 'ADMIN' || auth.user.role == 'zzzVENDORzzz'))" class="signature-button p-2 mb-8 bg-yellow-200 font-bold noprint" @click="clear()">Clear</button>&nbsp; 
            <button v-show="(form.status < 5 && (auth.user.role == 'ADMIN' || auth.user.role == 'zzzVENDORzzz'))" class="signature-button p-2 mb-8 bg-green-200 font-bold noprint" @click="this.save()">Save</button>&nbsp; 
            <text-input v-show="true" v-model="form.signature" id="signaturedata" :error="form.errors.signature" />
          </div>
        </div>
        
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <input type="number" v-model="form.status" v-bind:status='form.status' style="display:none!;" id="orderstatus" class="hide hidden" v-show="false" />

          <button v-if="((!order.deleted_at) && (auth.user.role == 'ADMIN') && (form.status < 5))" class="text-red-600 hover:underline noprint" tabindex="-1" type="button" @click="destroy">Delete Order</button>
          <loading-button v-if="(form.status < 5 && (auth.user.role == 'ADMIN' || auth.user.role == 'zzzVENDORzzz'))" :loading="form.processing" class="btn-indigo ml-auto noprint" type="submit">Save Order</loading-button>
          <button v-if="((auth.user.role == 'ADMIN') && (form.status == 5))" class="btn-indigo font-bold ml-auto noprint" @click="form.status = 0; finalize(0);">Unfinalize (ADMIN ONLY)</button>
        </div>
        
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <input type="checkbox" class="emailcheckbox" v-model="form.emailnotify" v-show="(auth.user.role == 'ADMIN' && form.status != 5)" />&nbsp; 
          <label for="emailnotify" v-show="(auth.user.role == 'ADMIN' && form.status != 5)" class="sendemailtext">Send email finalized notification</label>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100" v-show="(auth.user.role == 'ADMIN' && form.status != 5 && form.emailnotify == true)">
          <select-input v-model="form.contactuser" class="pb-8 pr-6 w-full lg:w-1/2" label="Vendor to notify order finalized">
            <option value="0">--No Email Contact--</option>
            <template v-for="u in users">
              <option :value="u.email">{{u.email}} - {{u.last_name}}, {{u.first_name}}</option>
            </template>
          </select-input>          
        </div>

        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="((auth.user.role == 'ADMIN') && (form.status < 5))" class="btn-indigo font-bold ml-auto noprint" @click="form.status = 5; finalize(5);">Finalize Order</button>
        </div>
        <input id="pordertype" type="hidden" :value="purchaseorder.data[0].ordertype" />
      </form>
    </div>
  </div>
<div id="updatejobsite"></div>
<button id="refreshnet" @click="getInventoryCurrentTotals()" class="hide"></button>
</template>
<style>
.emailcheckbox, .sendemailtext { font-weight:bold; font-size:18px; }
.colspacer {  border-left:1px solid black; }
#productsdata, #signaturedata { display:none; }
.onlyprint { display:none; }
.netproj { color:#00a8cd; font-weight:bold; color:#005c70;  }
.red { color:red; font-weight:bold; }
.tabulator-row .tabulator-cell {
  font-family:'Open Sans', Arial, Helvetica, sans-serif;
}
.highlightedcolumn { background:rgb(163 209 255 / 38%);}
#orderstable.loading { height:250px; }
.loading {
    height:250px;
		background: url('data:image/svg+xml;base64,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') 50% 50% no-repeat rgb(249,249,249);
}
.loading .tabulator-tableholder { opacity:0;}
  .button { border:1px solid #333; padding:4px 8px; }
/* PRINT */
@media print {
  .onlyprint { display:initial; }
  .noprint, #mainmenu { display:none; }
  * { border:0px solid #FFF !important; }
  #ordercontainer {box-shadow:none !important; }
  .nobreak, .nobreak canvas, .nobreak * { page-break-inside: avoid; }
  svg.dp__icon { display:none; }
  .tabulator-cell svg { display:none; }
}
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from '@vuepic/vue-datepicker'
import moment from 'moment'
import '@vuepic/vue-datepicker/dist/main.css'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import {InteractionModule} from 'tabulator-tables'
import Vue3Signature from "vue3-signature"
import { Input } from 'postcss'
import NProgress from 'nprogress'
import { booleanLiteral } from '@babel/types'
//import { table } from 'console'
import { jsPDF } from "jspdf";

export default {
  mounted() {
    this.purchaseorder.data.forEach( (v) => {
      if (v.id == this.order.purchaseorder_id) {
        document.querySelector('#pordertype').value = v.ordertype;
        if (!this.order.products) {
          document.querySelector('#productsdata').value = v.products;
          
        }
      }
    });
  },
  setup(props) {
  },
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker,
    Tabulator,
  },
  layout: Layout,
  props: {
    order: Object,
    notthisorders: Object,
    jobsites: Object,
    auth: Object,
    purchaseorder: Object,
    users: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        phone: this.order.phone,
        soldto: this.order.soldto,
        shipto: this.order.shipto,
        order_date: this.order.order_date,
        cutoff_date: this.order.cutoff_date,
        actual_delivery: this.order.actual_delivery,
        payment_terms: this.order.payment_terms,
        trader: this.order.trader,
        fob: this.order.fob,
        routing: this.order.routing,
        bid_id: this.order.bid_id,
        products: this.order.products,
        signature: this.order.signature,
        status: this.order.status,
        jobsite_id: this.order.jobsite_id,
        emailnotify: false,
        autodate: null,
        ordertype: this.purchaseorder.data[0].ordertype,
        contactuser: null,
      }),
      jsondata: JSON.parse(this.order.products),
    }
  },
  methods: {
  clear() {
    event.preventDefault();
    document.querySelector('#signaturedata').value = '';
    signature1.value.clear()
  },
   save(t) {
    var nv = '';
    try {
    event.preventDefault();
    var nv = signature1.value.save('image/svg+xml');
    document.querySelector('#signaturedata').value = nv;
    } catch(e) { console.warn(e); }
    //form.signature = nv;
    return nv;
    //this.save2(saveval);
  },
    jobsitedata() {
      return this.jobsites.data;
    },
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    //getInventoryCurrentTotals(ordersntorders,order,po) {
    getInventoryCurrentTotals() {  
      var input = [this.notthisorders,this.order,this.purchaseorder];
      //var input = JSON.parse(document.getElementById('refreshnet').getAttribute('netcalc'));
      var ordersntorders = input[0];
      var order = input[1];
      var po = input[2];
      var projnets = [];
      if (po.ordertype < 1) {
        ordersntorders.data.forEach((o,k) => {
          try { 
            if (o.editing) {
              if (o.products) {
                if (o.products.length > 0) {
                  var op = JSON.parse(o.products);
                  op.forEach((opr,productkey) => { 
                    
                    if (
                      (typeof(projnets[productkey]) == "undefined") ||
                      (projnets[productkey] == null) ||
                      (projnets[productkey] == "")
                    ) { projnets[productkey] = 0; }

                    if (opr.qty_ordered || opr.projected_delivery) {
                      projnets[productkey] += parseInt(opr.qty_ordered);
                    } 

                  })
                }
              }
            }
          } catch(e) { console.log(e); }
        });

        //delta this order
        try { 
          var p = JSON.parse(order.products);

          if (typeof(p) !== 'undefined' || p !== '' || p.length < 1) {
            this.purchaseorder.data.forEach( (v) => {
              if (v.id == this.order.purchaseorder_id) {
                p = JSON.parse(v.products);
              }
            });
          }

          p.forEach((opr,productkey) => { 
              projnets[productkey] = 0;

          });
        } catch(e) {
          console.error(e);
        }

        var keycheck = 1;
        var poqtys = JSON.parse(po.data[0].products);
        while (document.querySelectorAll('.tabulator-row').length > keycheck-1) {
          //var poselector = document.querySelector('.tabulator-row:nth-child(' + keycheck + ') .poqty');
          //try { var poqty = parseInt(poselector.innerHTML.split('.')[0].replace(',','').replace(',','')); }
          //catch(e) { var poqty = poselector.innerHTML; }
          try { 
            var poqtyparser = poqtys[keycheck-1].quantity.toString();
            var poqty = parseInt(poqtyparser.replace(',','').replace(',',''));
            var projecteddelta = parseInt(projnets[keycheck-1].toString().replace(',',''));
            document.querySelector('.tabulator-row:nth-child(' + keycheck + ') .colspacer').innerHTML =
                (poqty - projecteddelta);

            if ((poqty - projnets[keycheck-1]) < 1) {
              document.querySelector('.tabulator-row:nth-child(' + keycheck + ') .colspacer').classList.add('red');
            } else {
              document.querySelector('.tabulator-row:nth-child(' + keycheck + ') .colspacer').classList.add('netproj');
            }
          }
          catch(e) { console.log(e); }
          keycheck++;
        }  
      }    
      document.querySelector('#orderstable').classList.remove('loading');
    },
    savesig(signature1) {
      event.preventDefault();
      var nv = signature1.save();
      this.order.signature = nv;
      this.form.signature = nv;
    },
    saveitems() {
      event.preventDefault();
      this.order.products = this.tabledata;
      this.form.products = this.tabledata;
    },
    update() {
      event.preventDefault();
      if (document.querySelector('#productsdata').value.length > 0) {
        var storedata = JSON.parse(document.querySelector('#productsdata').value);
        this.order.products = JSON.stringify(storedata);
        this.form.products = JSON.stringify(storedata);
      } else { console.error(' Tabledata failure ')}

      this.order.signature = document.querySelector('#signaturedata').value;
      this.form.signature = document.querySelector('#signaturedata').value;

      this.form.put(`/orders/${this.order.id}`);
    },
    finalize(newStatus) {
      event.preventDefault();
      if (document.querySelector('#productsdata').value.length > 0) {
        var fixtdata = JSON.parse(document.querySelector('#productsdata').value);
        this.order.products = JSON.stringify(fixtdata);
        this.form.products = JSON.stringify(fixtdata);
        //this.tabledata = fixtdata;
      } else { console.error(' Tabledata failure ')}
      
      this.order.signature = document.querySelector('#signaturedata').value;
      this.form.signature = document.querySelector('#signaturedata').value;
        this.form.put(`/orders/${this.order.id}`);
    },
    destroy() {
      if (confirm('Are you sure you want to delete this order?')) {
        this.$inertia.delete(`/orders/${this.order.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this order?')) {
        this.$inertia.put(`/orders/${this.order.id}/restore`)
      }
    },
    pad(n) {
      return n.toString().padStart(5,"0");
    },
   /* PDF */
    makePDF() {
      event.preventDefault();
      window.print();
      /*
      // Default export is a4 paper, portrait, using millimeters for units
      const doc = new jsPDF();
      doc.html(document.getElementsByTagName('form'), {
        callback: function (doc) {
          doc.save();
        },
        x: 10,
        y: 10
      });
      */
    },
  },
}
</script>
<script setup>
  import {reactive, ref} from 'vue'

  const state = reactive({
    count: 0,
    option: {
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgb(242,242,242)"
    },
    disabled: false,
  })

  const signature1 = ref(null);
  
  const undo = () => {
    event.preventDefault();
    signature1.value.undo();
  }
  
  const addWaterMark = () => {
    event.preventDefault();
    signature1.value.addWaterMark({
      text: "mark text",          // watermark text, > default ''
      font: "20px Arial",         // mark font, > default '20px sans-serif'
      style: 'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
      fillStyle: "red",           // fillcolor, > default '#333'
      strokeStyle: "blue",	       // strokecolor, > default '#333'
      x: 100,                     // fill positionX, > default 20
      y: 200,                     // fill positionY, > default 20
      sx: 100,                    // stroke positionX, > default 40
      sy: 200                     // stroke positionY, > default 40
    });
  }
  
  const fromDataURL = (url) => {
    event.preventDefault();
    signature1.value.fromDataURL(url);
  }

  const handleDisabled = () => {
    //event.preventDefault();
    state.disabled = !state.disabled
    
  }

  const addRow = () => {
      event.preventDefault();
      Table.addData([{itemdesc:'', price:0, quantity:0, unit: ''}])
  };

  const importRows = () => {
    Table.import("csv", "/josephine-data-import.csv")
  };


  const dateOrderItems = function(button) {
    if (button !== null) {
    var alldate = new Date(button);
    alldate = moment(alldate);
    alldate = alldate.format('YYYY-MM-DD');
    } else { alldate = ''; }
    var tdata = Table.getData();
    var rowCount = Table.getDataCount();
    var counter = 0;
    while (counter <= rowCount) {
      try { tdata[counter].projected_delivery = alldate; } catch(e) { };
      counter++;
    }
    Table.replaceData(tdata);
  };

  const autoQtyUpdate = function() {
    var tdata = Table.getData();
    var rowCount = Table.getDataCount();
    var counter = 0;
    while (counter <= rowCount) {
      try { tdata[counter].qty_ordered = tdata[counter].quantity; } catch(e) { };
      counter++;
    }
    Table.replaceData(tdata);
  };

  var tabledata;
  var Table;
  

window.setTimeout(function() {
  var ordertyper = document.querySelector("#pordertype").value;
  var columnsRead = [
    {title:"PO Qty",field:"quantity",cssClass:"poqty",headerSort:false},
    {title:"",field:"unit",headerSort:false,width:10},
    {title:"Net",field:"projnet",cssClass:"colspacer highlightedcolumn",headerSort:false,width:60},
    {title:"Qty Ord",field:"qty_ordered",cssClass:"highlightedcolumn",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
    {title:"Proj. Date",field:"projected_delivery",cssClass:"highlightedcolumn",headerSort:false},
    {title:"T",field:"sizet",headerSort:false},
    {title:"W",field:"sizew",headerSort:false},
    {title:"L",field:"sizel",headerSort:false},
    {title:"Item",field:"itemdesc",headerSort:false,width:125},
    {title:"Category",field:"itemcategory",headerSort:false,width:100},
    {title:"T Qty",field:"totalqty",headerSort:false},
    {title:"",field:"totalunit",headerSort:false,width:20},
    {title:"id",field:"id",formatter:"rownum",headerSort:false},  
  ];
  var columnsWrite = [
    {title:"PO Qty",field:"quantity",cssClass:"poqty",headerSort:false},
    {title:"",field:"unit",headerSort:false,width:10},
    {title:"Net",field:"projnet",cssClass:"colspacer highlightedcolumn",headerSort:false,width:70},
    {title:"Qty Ord",field:"qty_ordered",cssClass:"highlightedcolumn",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
    {title:"Proj. Date",field:"projected_delivery",cssClass:"highlightedcolumn",editor:"date",headerSort:false},
    {title:"T",field:"sizet",headerSort:false},
    {title:"W",field:"sizew",headerSort:false},
    {title:"L",field:"sizel",headerSort:false},
    {title:"Item",field:"itemdesc",headerSort:false,width:125},
    {title:"Category",field:"itemcategory",headerSort:false,width:100},
    {title:"T Qty",field:"totalqty",headerSort:false},
    {title:"T Unit",field:"totalunit",headerSort:false,width:40},
    {title:"id",field:"id",formatter:"rownum",headerSort:false},  
  ];

  if (ordertyper == 'TRUSS') {
  var columnsRead = [
    {title:"id",field:"id",formatter:"rownum",headerSort:false},  
    {title:"PO Qty",field:"quantity",headerSort:false},
    //{title:"Net",field:"projnet",cssClass:"colspacer highlightedcolumn",headerSort:false,width:70},
    {title:"Qty Ord",field:"qty_ordered",cssClass:"highlightedcolumn",headerSort:false},
    {title:"Proj. Date",field:"projected_delivery",cssClass:"highlightedcolumn",editor:"date",headerSort:false},
    {title:"Span/L",field:"span",headerSort:false},
    {title:"Desc",field:"description",headerSort:false},
    {title:"TC Pitch",field:"tcpitch",headerSort:false},
    {title:"BC Pitch",field:"bcpitch",headerSort:false},
    {title:"TC Size",field:"tcsize",headerSort:false},
    {title:"BC Size",field:"tcsize",headerSort:false},
    {title:"Weight",field:"weight",headerSort:false},
    {title:"Weight2",field:"weight2",headerSort:false},
    {title:"Truss H",field:"trussheight",headerSort:false},
    {title:"Ship H",field:"shipheight",headerSort:false},
    {title:"Cat/Type",field:"itemcategory",headerSort:false},
    {title:"Section",field:"section",headerSort:false},
  ];

  var columnsWrite = [
    {title:"id",field:"id",formatter:"rownum",headerSort:false},  
    {title:"PO Qty",field:"quantity",headerSort:false},
    //{title:"Net",field:"projnet",cssClass:"colspacer highlightedcolumn",headerSort:false,width:70},
    {title:"Qty Ord",field:"qty_ordered",cssClass:"highlightedcolumn",headerSort:false},
    {title:"Proj. Date",field:"projected_delivery",cssClass:"highlightedcolumn",editor:"date",headerSort:false},
    {title:"Span/L",field:"span",headerSort:false},
    {title:"Desc",field:"description",headerSort:false},
    {title:"TC Pitch",field:"tcpitch",headerSort:false},
    {title:"BC Pitch",field:"bcpitch",headerSort:false},
    {title:"TC Size",field:"tcsize",headerSort:false},
    {title:"BC Size",field:"tcsize",headerSort:false},
    {title:"Weight",field:"weight",headerSort:false},
    {title:"Weight2",field:"weight2",headerSort:false},
    {title:"Truss H",field:"trussheight",headerSort:false},
    {title:"Ship H",field:"shipheight",headerSort:false},
    {title:"Cat/Type",field:"itemcategory",headerSort:false},
    {title:"Section",field:"section",headerSort:false},
    {title:"",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() { cell.getRow().delete(); },5); }},
  ];
}
  if (ordertyper == 'HARDWARE') {
    columnsRead = [
      {title:"id",field:"id",formatter:"rownum",headerSort:false},  
      {title:"PO Qty",field:"quantity",headerSort:false},
      {title:"Qty Ord",field:"qty_ordered",cssClass:"highlightedcolumn",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
      {title:"Proj. Date",field:"projected_delivery",cssClass:"highlightedcolumn",editor:"date",headerSort:false},
      {title:"Unit",field:"unit",headerSort:false},
      {title:"Item",field:"itemdesc",headerSort:false},
      {title:"Mfg",field:"mfg",headerSort:false},
      {title:"Unit Cost",field:"unitcost",headerSort:false},
    ];

    columnsWrite = [
      {title:"id",field:"id",formatter:"rownum",headerSort:false},  
      {title:"PO Qty",field:"quantity",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
      {title:"Qty Ord",field:"qty_ordered",cssClass:"highlightedcolumn",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
      {title:"Proj. Date",field:"projected_delivery",cssClass:"highlightedcolumn",editor:"date",headerSort:false},
      {title:"Unit",field:"unit",editor:"input",headerSort:false},
      {title:"Item",field:"itemdesc",editor:"input",headerSort:false},
      {title:"Mfg",field:"mfg",editor:"input",headerSort:false},
      {title:"Unit Cost",field:"unitcost",editor:"input",headerSort:false},
      //{title:"Category",field:"itemcategory",editor:"input",headerSort:false},
      {title:"",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() { cell.getRow().delete(); },5); }},
    ];
  }
  
  var formstatus = parseInt(document.querySelector("#orderstatus").getAttribute('status')) == 5;
  var ordertype = parseInt(document.querySelector('#pordertype').value);
  Table = new Tabulator("#orderstable", {
    reactiveData:false, //enable reactive data
    data:this.tabledata,
    columns: (formstatus ? columnsRead : columnsWrite),
    //{title:"Price",field:"price",editor:"number",editorParams:{min:0,max:9999999999,step:0.01},formatter:"money",formatterParams:{decimal:".",thousand:",",symbol:"$",symbolAfter:"",precision:false}},
    //{title:"",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() { cell.getRow().delete(); },5); }},
  });
  
  Table.on("cellEdited", function(cell) {
    tabledata = Table.getData();
    document.querySelector('#productsdata').value = JSON.stringify(tabledata);
  });
    
  window.setTimeout(function() {
    var pdval = document.querySelector('#productsdata').value;
    if ((typeof(pdval) !== 'undefined') && (pdval.length > 0)) {
      try {
        var newtd = JSON.parse(pdval); 
        Table.replaceData(newtd).then(function(){
          window.setTimeout(function() { document.querySelector('#refreshnet').click(); },1500);
        }).catch(function(e) { console.error(e);  });
        
      } catch(e) {
        console.error(e);
        console.info('Table data empty - probably not save anything to it.');
        
        window.setTimeout(function() { document.querySelector('#refreshnet').click(); },1500);
      }
    } else {
      console.warn('No Order Projections found.');
      
      window.setTimeout(function() { document.querySelector('#refreshnet').click(); },1500);
    }
  },100);

  if (parseInt(document.querySelector("#orderstatus").getAttribute('status')) == 5) { handleDisabled(); }
  
},1);
</script>